/**
 * Allows the caching of Intl.DateTimeFormat objects by locale.
 */
class DateTimeFormatCache {
    /**
     * Creates a new Intl.DateTimeFormat cache.
     * @param options {object} the formatting options that should be passed to each Intl.DateTimeFormat
     */
    constructor(options) {
        this.options = options;
        this.formattersByLocale = {};
    }

    /**
     * Returns an Intl.DateTimeFormat instance for the given locale.
     * @param locale {string}
     * @returns {Intl.DateTimeFormat}
     */
    getFormatter(locale) {
        let formatter = this.formattersByLocale[locale];

        if (!formatter) {
            formatter = new Intl.DateTimeFormat(locale, this.options);
            this.formattersByLocale[locale] = formatter;
        }

        return formatter;
    }
}

export default DateTimeFormatCache;
